(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // === GLCE: Hover to open header menus (mega + dropdown) ===
  class HeaderHoverMenu {
    constructor() {
      this.closeDelay = 200;
      this.closeTimer = null;
      this.bind();
      // 主题编辑器里 header 区块重载后，重新绑定
      document.addEventListener('shopify:section:load', () => this.bind());
    }

    get hoverCapable() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    bind() {
      if (!this.hoverCapable) return;
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu.dataset.hoverBound) return;       // 防止重复绑定
        const details = menu.querySelector('details');
        if (!details) return;
        menu.dataset.hoverBound = 'true';

        const summary = details.querySelector('summary');
        const panel = details.querySelector('.mega-menu__content, .header__submenu');

        [summary, panel].forEach((el) => {
          if (el) el.addEventListener('mouseenter', () => this.open(menu, details));
        });
        [summary, panel].forEach((el) => {
          if (el) el.addEventListener('mouseleave', () => this.scheduleClose(menu, summary, panel));
        });
      });
    }

    open(currentMenu, details) {
      clearTimeout(this.closeTimer);
      // 先关掉其他已打开的菜单（用 Dawn 自己的 close，保证状态干净）
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== currentMenu && typeof menu.close === 'function') menu.close();
      });
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
        // 动画只在「从关闭→打开」时播一次。已经打开（鼠标在 summary→panel 间移动）不重播
        const panel = details.querySelector('.mega-menu__content');
        if (panel) {
          panel.classList.remove('glce-anim-in');
          void panel.offsetHeight;
          panel.classList.add('glce-anim-in');
        }
      }
    }

    scheduleClose(menu, summary, panel) {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        const stillInside =
          (summary && summary.matches(':hover')) ||
          (panel && panel.matches(':hover'));
        if (stillInside) return;

        if (typeof menu.close === 'function') menu.close();
        else menu.querySelector('details')?.removeAttribute('open');
      }, this.closeDelay);
    }
  }

  // === GLCE: By Voltage 左右联动 ===
  class VoltageMegaMenu {
    constructor() {
      this.bind();
      document.addEventListener('shopify:section:load', () => this.bind());
    }

    bind() {
      document.querySelectorAll('.glce-voltage-mega').forEach((mega) => {
        if (mega.dataset.voltageBound) return;
        mega.dataset.voltageBound = 'true';

        const navItems = mega.querySelectorAll('.glce-voltage-nav__item');
        const grids = mega.querySelectorAll('.glce-voltage-grid');
        const viewAll = mega.querySelector('.glce-voltage-viewall');

        navItems.forEach((item) => {
          item.addEventListener('mouseenter', () => {
            const target = item.dataset.collection;
            // 切换左侧高亮
            navItems.forEach((n) => n.classList.remove('glce-voltage-nav__item--active'));
            item.classList.add('glce-voltage-nav__item--active');
            // 切换右侧显示
            // 切换右侧显示
            grids.forEach((g) => {
              g.classList.toggle('glce-voltage-grid--hidden', g.dataset.collection !== target);
            });
            // 同步 View All 的目标集合
            if (viewAll) viewAll.href = item.href;
          });
        });
      });
    }
  }

  customElements.whenDefined('header-menu').then(() => {
    new HeaderHoverMenu();
    new VoltageMegaMenu();
  });

  // 等自定义元素注册完再初始化，避免 defer 加载顺序问题
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whyofficialweb"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__gwbInit) return;
  window.__gwbInit = true;
  var lastFocused = null;
  var savedScrollY = 0;

  /* iOS Safari 在 <html> 上设 overflow:hidden 会丢掉滚动位置,恢复时会回到顶部,
     所以必须自己存下来再还原。聚焦也要禁掉自动滚动,否则同样会跳。 */
  function focusNoScroll(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); }
  }

  function openModal(id) {
    var m = document.getElementById(id);
    if (!m) return;
    lastFocused = document.activeElement;
    savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (m.parentNode !== document.body) { document.body.appendChild(m); }
    m.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    focusNoScroll(m.querySelector('.gwb-modal__close'));
  }

  function closeModal(m) {
    if (!m) return;
    m.hidden = true;
    document.documentElement.style.overflow = '';
    window.scrollTo(0, savedScrollY);
    focusNoScroll(lastFocused);
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-gwb-open]');
    if (opener) { openModal(opener.getAttribute('data-gwb-open')); return; }
    var closer = e.target.closest('[data-gwb-close]');
    if (closer) { closeModal(closer.closest('.gwb-modal')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.gwb-modal:not([hidden])');
      if (open) closeModal(open);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
